import { switchMap, takeUntil } from "rxjs/operators";

import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { SiteService as SiteServiceCulture } from "src/app/services/site.service";
import { CategoryService } from "src/app/e-commerce/common/category/ecommerce-service";
// import { SiteService } from 'src/app/services/site.service'';

import { PagesService } from "../../pages/pages.service";

import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { slideTrigger } from "src/app/events-calendar/common/animation/triggers/slideTrigger";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { EStatus } from "src/app/models/general-enums";
import { ECategoryTypes } from "src/app/site-menu/site-menu/common/models/enums";
import { Categories } from "../categories";

@Component({
  selector: "app-add-edit-site-category",
  templateUrl: "./add-edit-site-category.component.html",
  styleUrls: ["./add-edit-site-category.component.css"],
  animations: [
    slideTrigger,
    trigger('zipper', [
      state('collapsed', style({ height: '0px', overflow: 'hidden', paddingTop: '0px', paddingBottom: '0px' })),
      state('expanded', style({ height: '*', paddingTop: '*', paddingBottom: '*' })),
      transition('collapsed <=> expanded', [animate('400ms ease-in-out')])
    ])
  ]
})
export class AddEditSiteCategoryComponent implements OnInit {
  reference: any;
  pageDestroy$ = new Subject();
  allSiteTypes = [];
  siteCultures: any[];
  activeTab: any = 0;
  activeInnerTab: any = 1;

  id: number;
  form: FormGroup;
  constructor(
    public siteService: SiteService,
    public siteServiceCulture: SiteServiceCulture,
    private snotifyService: ToastrService,
    public pagesService: PagesService,
    private categoryService: CategoryService,
    private dialogRef: MatDialogRef<AddEditSiteCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.id = data ? Number(data.id) : null
  }

  ngOnInit() {
    this.siteService.siteCategories$
      .pipe(takeUntil(this.pageDestroy$))
      .subscribe((res: any) => {
        if (res && res.length) {
          this.allSiteTypes = res.filter(
            (el) => el.id != ECategoryTypes.Product
          );
        }
      });


    this.form = new FormGroup({
      id: new FormControl(0, Validators.required),
      thumbnailImageId: new FormControl(null),
      coverImageId: new FormControl(null),
      displayOrder: new FormControl(0),
      parentId: new FormControl(null),
      includeInMenu: new FormControl(false),
      status: new FormControl(EStatus.Published),
      categoryDetails: new FormArray([]),
      categoryTypeId: new FormControl(null, Validators.required),
    });
    this.getUsedCulture()
  }

  getcategoryById() {
    this.categoryService.getCategoriesById(this.id).subscribe((res: Categories) => {
      this.form.patchValue(res);
      this.form.setControl('categoryDetails', this.setEditCategoryCultures(this.siteCultures, res.categoryDetails))

    })
  }

  close() {
    this.dialogRef.close(true);
  }


  setNewCategoryCultures(culturesSet): AbstractControl {
    const formArray = [];
    let i = 0;
    for (let item of culturesSet) {
      const group = new FormGroup({
        status: new FormControl(EStatus.Published),
        name: new FormControl('', Validators.required),
        slug: new FormControl(''),
        slugInfoId: new FormControl(0),
        metaTitle: new FormControl(''),
        metaKeywords: new FormControl(''),
        cultureId: new FormControl(item.id),
        description: new FormControl(''),
        categoryTemplateId: new FormControl(0),
        cultureName: new FormControl(item.name),
      });

      formArray.push(group);
      i++;
    }

    return new FormArray(formArray)
  }

  setEditCategoryCultures(culturesSet, payload: any[]): AbstractControl {
    const formArray = [];
    let i = 0;
    let firstPublishedTab = -1;
    for (let item of culturesSet) {
      const target = payload.find(x => x.cultureId === item.id)
      const group = new FormGroup({
        status: new FormControl(target ? (target.status === 1 ? false : true) : false),
        name: new FormControl(target ? target.name : '', Validators.required),
        cultureId: new FormControl(item.id),
        description: new FormControl(target ? target.description : ''),
        cultureName: new FormControl(item.name),
        slug: new FormControl(target ? target.slug : ''),
        slugInfoId: new FormControl(target && target.slugInfoId ? target.slugInfoId : 0),
        metaTitle: new FormControl(target && target.metaTitle ? target.metaTitle : ''),
        metaKeywords: new FormControl(target && target.metaKeywords ? target.metaKeywords : ''),
        categoryTemplateId: (target && target.metaKeywords ? target.categoryTemplateId : 0),
      });

      formArray.push(group);
      if (firstPublishedTab === -1 && target && target.status !== 1) {
        this.activeTab = i;
      }

      i++;
    }

    return new FormArray(formArray)
  }




  updateActiveTab(v) {
    this.activeTab = this.activeTab == v ? null : v;
    this.activeInnerTab = 1;
  }

  updateActiveInnerTab(v) {
    this.activeInnerTab = this.activeInnerTab === v ? 0 : v;
  }

  updateSlug(index) {
    if (!this._cultures.controls[index].get('slug').value)
      this._cultures.controls[index].patchValue({
        slug: this._cultures.controls[index].get('name').value.replace(/\s/g, '-')
          .replace(/\'+/g, "-")
          .toLowerCase()
      })

  }

  getUsedCulture() {
    this.siteServiceCulture.getUsedSiteCultures(2).subscribe(
      res => {
        this.siteCultures = res;
        if (this.id) {
          this.getcategoryById();
        } else {
          this.form.setControl('categoryDetails', this.setNewCategoryCultures(this.siteCultures));
        }

      },
      err => this.snotifyService.error(err.message)
    );
  }


  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let action$ = this.id ? this.categoryService.updateCategory(this.form.value) : this.categoryService.addNewCategory(this.form.value);


    action$.pipe(switchMap((x) => {
      return this.pagesService.getAll();
    })).subscribe(
      (rea: any) => {
        this.openNotifySuccess(this.id ? "Category Updated Successfully " : "Category Saved Successfully ")
        this.close()
        this.pageDestroy$.next(true)
      },

      err => {
        console.log(err)
        this.openNotifyError(err.message)
      }


    )
  }


  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }



  checkBehaver(index) {


    return ( this._cultures.controls[index].get('slug').value != null && this._cultures.controls[index].get('slug').value != ''  && this.id) ? true : false
  }

  get _cultures() {
    return this.form.get('categoryDetails') as FormArray;
  }

  get _categoryTypeId() {
    return this.form.get("categoryTypeId");
  }

  get _name() {
    return this.form.get("name");

  }




}
